import {
  Button,
  Card, Icon,
  notification, Popconfirm,
  Tooltip
} from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormUtils, TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import Request from '../../../request'
import styles from './styles.less'
import { allUserExportFxn, getAllUsersFxn } from '../actions'
import EditUser from '../drawers/editUser'
import MemberHistory from '../../article/reviewer/memberHistory'
import { onlineSubmissionExportFxn } from '../../onlineSubmission/actions'
import { apiUrl } from '../../../settings'
import ChangePasswordDrawer from '../drawers/changePassword'

const regExpFilters = ['name', 'local.email', 'userType']

class AllUsers extends Component {
  events = {
    showEdit: (data) => {
      this.setState({
        visible: true, userId: data._id,
        userType: data.userType
      })
    },
    hideEdit: () => {
      this.setState({
        visible: false, userId: '', userType: ''
      })
    },
    onSubmit: () => {
      this.setState({
        visible: false, userId: '', userType: ''
      }, () => {
        this.table.current.reload()
      })
    },
    showHistory: (data) => {
      this.setState({
        reviewerState: {
          visible: true,
          reviewerId: data.reviewer_Id,
          data: {
            reviewerId: data.reviewerId,
            name: data.name
          }
        }
      })
    },
    hideHistory: () => {
      this.setState({
        reviewerState: {
          visible: false,
          reviewerId: '',
          data: {}
        }
      })
    }
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.state = {
      userId: '',
      visible: false,
      userType: '',
      reviewerState: {
        visible: false,
        data: {}
      },
      changePasswordVisible: false,
      changePasswordUserId: ''
    }
  }

  showChangePassword = (record) => {
    this.setState({
      changePasswordVisible: true,
      changePasswordUserId: record._id
    })
  }

  hideChangePassword = () => {
    this.setState({
      changePasswordVisible: false,
      changePasswordUserId: ''
    })
  }

  changePasswordSuccessful = () => {
    this.setState({
      changePasswordVisible: false,
      changePasswordUserId: ''
    })
    this.table.current.reload()
  }

  apiRequest = params => {
    let { dispatch } = this.props
    return new Promise(async resolve => {
      let data = await dispatch(
        getAllUsersFxn({
          ...params,
          results: 5000,
          count: 5000,
          regExFilters: regExpFilters
        })
      )
      this.setState({
        filteredUsers: data.data
      })
      resolve(data)
    })
  }

  deleteUser = params => {
    Request.deleteUserApi(params).then(data => {
      if (data.type) {
        notification.success({
          message: data.msg
        })
        this.reload()
      } else {
        notification.error({
          message: data.msg
        })
      }
    })
  }

  reload = () => {
    this.table.current.reload()
  }
  exportExcel = async () => {
    let { dispatch } = this.props
    const { filteredUsers } = this.state
    let resp = await dispatch(allUserExportFxn({ data: filteredUsers }))
    if (resp && resp.success) {
      window.open(`${apiUrl}${resp.fileName}`, 'Download')
    }
  }

  componentDidMount() {
  }

  render() {
    let { currentUser } = this.props
    let { state: { visible, userId, userType, reviewerState }, events } = this

    const standardUserTypes = [
      'Admin',
      'Author',
      'Institute',
      'Reviewer',
      'User'
    ]
    let userTypeFilters = standardUserTypes.map(t => ({ text: t, value: t }))

    const columns = [
      {
        title: 'Name',
        key: 'name',
        sorter: true,
        dataIndex: 'name',
        searchTextName: 'name',
        filterByRegex: true,
        fixed: 'left',
        width: 130
      },
      {
        title: 'Email',
        dataIndex: 'local.email',
        key: 'local.email',
        filterByRegex: true,
        searchTextName: 'local.email',
        fixed: 'left',
        width: 150
      },
      {
        title: 'User Type',
        dataIndex: 'userType',
        key: 'userType',
        filters: userTypeFilters
      },
      {
        title: 'Reviewer Id',
        dataIndex: 'reviewerId',
        key: 'reviewerId',
        searchTextName: 'userType',
        filterByRegex: true
      },
      ...(currentUser && currentUser.isAdmin
        ? [{
          title: 'Password',
          dataIndex: 'displayPassword',
          key: 'displayPassword',
          searchTextName: 'displayPassword',
          filterByRegex: true,
          width: '120px'
        }]
        : []),
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        width: 180
      },
      {
        title: 'Institute',
        dataIndex: 'instituteAddress',
        key: 'instituteAddress',
        width: 180
      },
      {
        title: 'Designation',
        dataIndex: 'designation',
        key: 'designation'
      },
      {
        title: 'MobileNo',
        dataIndex: 'mobileNo',
        key: 'mobileNo'
      },

      {
        title: 'userName',
        dataIndex: 'userName',
        key: 'userName'
      },
      {
        title: 'Country',
        dataIndex: 'country',
        key: 'country'
      },
      {
        key: 'actions',
        width: 150,
        fixed: 'right',
        render: (item, record) => {
          return (
            <div className={'wrapRow'}>
              {item.userType == 'User' ? (
                <React.Fragment>
                  <Tooltip title='Show Details'>
                    <Popconfirm
                      title={'Are you sure, you want to delete user?'}
                      onConfirm={() => {
                        this.deleteUser(item)
                      }}>
                      <a className={'btn round btn-danger btn-sm'}>
                        <Icon type={'delete'} /> Delete
                      </a>
                    </Popconfirm>
                  </Tooltip>
                </React.Fragment>
              ) : null}

              {['User', 'Author'].includes(item.userType) ?
                <a className={'btn round btn-default btn-sm'} onClick={() => {
                  this.events.showEdit(record)
                }}>Edit</a> : null}

              {item.userType == 'Reviewer' ?
                <a className={'btn round btn-default btn-sm'} onClick={() => {
                  this.events.showHistory(record)
                }}>History</a> : null}

              <a className={'btn round btn-default btn-sm'} style={{ marginTop: '6px' }} onClick={() => {
                this.showChangePassword(record)
              }}>Change Password</a>

            </div>
          )
        }
      }
    ]
    return (
      <PageHeaderWrapper title={'All Users'} content={[
        <>
          <Button
            key='1'
            type='primary'
            onClick={() => {
              this.exportExcel()
            }}>
            <Icon type={'file'} />
            Export
          </Button>
        </>
      ]}>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            extraProps={{ scroll: { x: 1800 } }}
            columns={columns}
            apiRequest={this.apiRequest}
          />
        </Card>

        {visible ? <EditUser
          visible={visible} userId={userId}
          userType={userType}
          onSubmit={events.onSubmit}
          onClose={events.hideEdit} /> : ''}


        {reviewerState.visible ? (
          <MemberHistory
            {...reviewerState}
            onClose={events.hideHistory}
          />
        ) : null}

        {this.state.changePasswordVisible ? (
          <ChangePasswordDrawer
            visible={this.state.changePasswordVisible}
            userId={this.state.changePasswordUserId}
            onClose={this.hideChangePassword}
            onSubmitSuccess={this.changePasswordSuccessful}
          />
        ) : null}

      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = (
  {
    global
  }
) => (
  {
    categories: global.categories,
    currentUser: global.currentUser
  }
)
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUsers)
